import type React from 'react';
import { observer } from 'mobx-react';

import EmailIcon from 'src/components/common/Icons/EmailIcon';
import MoveIcon from 'src/components/common/Icons/MoveIcon';
import type { IJobApplicationStore } from 'src/stores/JobApplicationStore';
import type { Bucket } from 'src/stores/JobApplicationStore/types';
import BulkActionItem from './BulkActionItem';
import UpdateStatusFormProvider from './BulkUpdateStatus/UpdateStatusForm';
import SendBulkProspectEmail from './SendBulkProspectEmail';
import { BULK_ACTION } from './hooks/useBulkActionItemInfo';

interface Props {
  jobApplicationStore: IJobApplicationStore;
  updateStatusForSelectedApplications: (bucket: Bucket) => Promise<boolean>;
  disabled: boolean;
}

const BulkActions: React.FC<Props> = ({
  jobApplicationStore,
  updateStatusForSelectedApplications,
  disabled = true,
}) => (
  <>
    <BulkActionItem
      jobApplicationStore={jobApplicationStore}
      bulkAction={BULK_ACTION.EMAIL}
      disabled={disabled}
      icon={<EmailIcon weight={disabled ? 'weak' : 'regular'} />}
    >
      {({
        onCancel,
        closeAndShowSuccessMessage,
        selectedJobApplicationsCount,
      }) => (
        <SendBulkProspectEmail
          onCancel={onCancel}
          closeAndShowSuccessMessage={closeAndShowSuccessMessage}
          jobApplicationStore={jobApplicationStore}
          selectedJobApplicationsCount={selectedJobApplicationsCount}
        />
      )}
    </BulkActionItem>
    <BulkActionItem
      jobApplicationStore={jobApplicationStore}
      bulkAction={BULK_ACTION.MOVE}
      disabled={disabled}
      icon={<MoveIcon weight={disabled ? 'weak' : 'regular'} />}
    >
      {({
        closeAndShowSuccessMessage,
        onCancel,
        selectedJobApplicationsCount,
        enableModal,
        disableModal,
      }) => (
        <UpdateStatusFormProvider
          jobApplicationStore={jobApplicationStore}
          updateStatusForSelectedApplications={
            updateStatusForSelectedApplications
          }
          closeAndShowSuccessMessage={closeAndShowSuccessMessage}
          onCancel={onCancel}
          selectedJobApplicationsCount={selectedJobApplicationsCount}
          enableModal={enableModal}
          disableModal={disableModal}
        />
      )}
    </BulkActionItem>
  </>
);

export default observer(BulkActions);

export { BulkActions };
